import React from 'react'
import Helmet from 'react-helmet'
import { graphql, StaticQuery } from 'gatsby'
import styled from '@emotion/styled'
import GlobalStyles from '../components/GlobalStyles'
import CloseButton from './CloseButton';
import logo from '../data/img/logo.jpg';
import logoicon from '../data/img/logo_icon.png';
import ProgressBar from './ProgressBar';
import Loading from './Loading';
import layoutStyles from './layout.module.scss';

function Layout ({ data, children, robots }) {
  const {
    site: {
      siteMetadata: { title }
    }
  } = data

  // Unless specified, robots value should be noindex nofollow
  if ( !robots ) {
    robots = "noindex,nofollow";
  } 

  const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    height: 100%;
  `;

  return (
    <>
      <GlobalStyles />
      <Helmet>
        <title>{title}</title>
        <meta name="description" content="Use the ONCO product questionnaire to find the HVAC or plumbing part that your project needs." />
        <meta name="robots" content={robots} />
        <html lang="en" />
        <noscript>This site runs best with JavaScript enabled.</noscript>
        <link rel="shortcut icon" href="https://onco-tx.com/wp-content/uploads/2019/08/favicon_2.png" type="image/x-icon"></link>
      </Helmet>
          <Container>
            <div className={layoutStyles.header}>
              <div className={layoutStyles.container}>
                <img className={layoutStyles.logo} src={logo}/>
                <CloseButton></CloseButton>
              </div>
            </div>
            <ProgressBar></ProgressBar>
            <Loading></Loading>
            <div className={layoutStyles.contentWrapper}>
              <img className={layoutStyles.logoicon} src={logoicon}/>
              { children }
            </div>
          </Container>
    </>
  )
}

export default function LayoutWithSiteData (props) {
  return (

    <StaticQuery
      query={graphql`
        {
          site {
            siteMetadata {
              title
              description
              author
              keywords
            }
          }
        }
      `}
      render={data => <Layout data={data} {...props} />}
    />
  )
}
